import 'balloon-css';
import React from 'react';
import axios from 'axios';
import { serialize } from 'object-to-formdata';

export class PortRequestDetails extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            fields: {
                name: '', 
                email: '', 
                company: '', 
                company_reg_no: '',
                job_title: '',
                billing_property_name_number: '',
                billing_street_name: '',
                billing_town_city: '',
                billing_county: '',
                billing_postcode: '',
                number: '',
                current_provider: '',
                billing_acct_no: '',
                latest_bill: '',
                installation_property_name_number: '',
                installation_street_name: '',
                installation_town_city: '',
                installation_county: '',
                installation_postcode: ''
            },
            errors: {
                name: '',
                email: '', 
                company: '', 
                company_reg_no: '',
                job_title: '',
                billing_property_name_number: '', 
                billing_street_name: '',
                billing_town_city: '',
                billing_county: '',
                billing_postcode: '',
                number: '',
                current_provider: '',
                billing_acct_no: '',
                latest_bill: '',
                installation_property_name_number: '',
                installation_street_name: '',
                installation_town_city: '',
                installation_county: '',
                installation_postcode: '',
                generic: false
            },
            loading: false,
            submitted: false,
            addressMatch: false,
            confirm: false
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);

        this.handleCompanyChange = this.handleCompanyChange.bind(this);
        this.handleCompanyRegNoChange = this.handleCompanyRegNoChange.bind(this);
        this.handleJobTitleChange = this.handleJobTitleChange.bind(this);

        this.handleBillingPropertyNameNumberChange = this.handleBillingPropertyNameNumberChange.bind(this);
        this.handleBillingStreetNameChange = this.handleBillingStreetNameChange.bind(this);
        this.handleBillingTownCityChange = this.handleBillingTownCityChange.bind(this);
        this.handleBillingCountyChange = this.handleBillingCountyChange.bind(this);
        this.handleBillingPostcodeChange = this.handleBillingPostcodeChange.bind(this);

        this.handleBillingAcctNoChange = this.handleBillingAcctNoChange.bind(this);
        this.handleNumberChange = this.handleNumberChange.bind(this);
        this.handleCurrentProviderChange = this.handleCurrentProviderChange.bind(this);
        this.handleLatestBillChange = this.handleLatestBillChange.bind(this);

        this.handleInstallationPropertyNameNumberChange = this.handleInstallationPropertyNameNumberChange.bind(this);
        this.handleInstallationStreetNameChange = this.handleInstallationStreetNameChange.bind(this);
        this.handleInstallationTownCityChange = this.handleInstallationTownCityChange.bind(this);
        this.handleInstallationCountyChange = this.handleInstallationCountyChange.bind(this);
        this.handleInstallationPostcodeChange = this.handleInstallationPostcodeChange.bind(this);

        this.handleAddressMatchChange = this.handleAddressMatchChange.bind(this);
        this.handleConfirmChange = this.handleConfirmChange.bind(this);
        this.handleSubmitClick = this.handleSubmitClick.bind(this);
        this.handleHomeClick = this.handleHomeClick.bind(this);
    }

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const prefill = {};
        const mapping = {
            name: 'name',
            email: 'email',
            number: 'number',
            billing_town_city: 'billing_town_city',
            billing_postcode: 'billing_postcode'
        };
        Object.entries(mapping).forEach(([param, field]) => {
            const val = params.get(param);
            if (val) prefill[field] = val;
        });
        if (Object.keys(prefill).length > 0) {
            this.setState(prev => ({ fields: { ...prev.fields, ...prefill } }));
        }
    }

    handleHomeClick() {
        window.location.href = "https://1310.io/";
    }

    handleAddressMatchChange() {
        this.setState({addressMatch: !this.state.addressMatch}, function() {
            if (this.state.addressMatch) {
                let fields = this.state.fields;
                fields["installation_property_name_number"] = this.state.fields.billing_property_name_number;
                fields["installation_street_name"] = this.state.fields.billing_street_name;
                fields["installation_town_city"] = this.state.fields.billing_town_city;
                fields["installation_county"] = this.state.fields.billing_county;
                fields["installation_postcode"] = this.state.fields.billing_postcode;
                this.setState({ fields });
            }
            else {
                let fields = this.state.fields;
                fields["installation_property_name_number"] = '';
                fields["installation_street_name"] = '';
                fields["installation_town_city"] = '';
                fields["installation_county"] = '';
                fields["installation_postcode"] = '';
                this.setState({ fields });
            }
        });
    }

    handleConfirmChange() {
        this.setState({confirm: !this.state.confirm});
    }

    async handleSubmitClick() {
        if (this.handleValidation()) {
            this.setState({ loading: true });

            const config = {     
                headers: { 'content-type': 'multipart/form-data' }
            }
            
            const formData = serialize(this.state.fields);

            await axios.post(process.env.REACT_APP_THIRTEEN_TEN_API + '/NumberPort/request', formData, config)
                .then(response => {
                    this.setState({ submitted: true }, function() {
                        document.getElementById("submittedConfirmation").scrollIntoView({ block: 'end',  behavior: 'smooth' });
                    });
                })
                .catch(() => {
                    let errors = this.state.errors;
                errors.generic = true;
                this.setState({errors});
                })
                .finally(() => {
                    this.setState({ loading: false });
                });
        }
    }

    handleNameChange(e) {
        const newName = e.target.value;
        let fields = this.state.fields;
        fields["name"] = newName;
        this.setState({ fields });
    }

    handleEmailChange(e) {
        const newEmailAddress = e.target.value;
        let fields = this.state.fields;
        fields["email"] = newEmailAddress;
        this.setState({ fields });
    }

    handleCompanyChange(e) {
        const newCompany = e.target.value;
        let fields = this.state.fields;
        fields["company"] = newCompany;
        this.setState({ fields });
    }

    handleCompanyRegNoChange(e) {
        const newCompanyRegNo = e.target.value;
        let fields = this.state.fields;
        fields["company_reg_no"] = newCompanyRegNo;
        this.setState({ fields });
    }

    handleJobTitleChange(e) {
        const newJobTitle = e.target.value;
        let fields = this.state.fields;
        fields["job_title"] = newJobTitle;
        this.setState({ fields });
    }

    handleBillingPropertyNameNumberChange(e) {
        const newBillingPropertyNameNumber = e.target.value;
        let fields = this.state.fields;
        fields["billing_property_name_number"] = newBillingPropertyNameNumber;

        if (this.state.addressMatch) {
            fields["installation_property_name_number"] = newBillingPropertyNameNumber;
        }

        this.setState({ fields });
    }

    handleBillingStreetNameChange(e) {
        const newBillingStreetName = e.target.value;
        let fields = this.state.fields;
        fields["billing_street_name"] = newBillingStreetName;

        if (this.state.addressMatch) {
            fields["installation_street_name"] = newBillingStreetName;
        }

        this.setState({ fields });
    }

    handleBillingTownCityChange(e) {
        const newBillingTownCity = e.target.value;
        let fields = this.state.fields;
        fields["billing_town_city"] = newBillingTownCity;

        if (this.state.addressMatch) {
            fields["installation_town_city"] = newBillingTownCity;
        }

        this.setState({ fields });
    }

    handleBillingCountyChange(e) {
        const newBillingCounty = e.target.value;
        let fields = this.state.fields;
        fields["billing_county"] = newBillingCounty;
        this.setState({ fields });
    }

    handleBillingPostcodeChange(e) {
        const newBillingPostcode = e.target.value;
        let fields = this.state.fields;
        fields["billing_postcode"] = newBillingPostcode;

        if (this.state.addressMatch) {
            fields["installation_postcode"] = newBillingPostcode;
        }

        this.setState({ fields });
    }

    handleNumberChange(e) {
        const newNumber = e.target.value;
        let fields = this.state.fields;
        fields["number"] = newNumber;
        this.setState({ fields });
    }

    handleCurrentProviderChange(e) {
        const newCurrentProvider = e.target.value;
        let fields = this.state.fields;
        fields["current_provider"] = newCurrentProvider;
        this.setState({ fields });
    }

    handleBillingAcctNoChange(e) {
        const newBillingAcctNo = e.target.value;
        let fields = this.state.fields;
        fields["billing_acct_no"] = newBillingAcctNo;
        this.setState({ fields });
    }

    handleLatestBillChange(e) {
        let fields = this.state.fields;
        let errors = this.state.errors;
        var ext = e.target.value?.match(/\.([^\.]+)$/)[1];
        switch (ext) {
            case 'pdf':
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
            case 'webp':
            case 'tif':
            case 'tiff':
            case 'bmp':
            case 'svg':
                const newLatestBill = e.target.files[0];
                fields["latest_bill"] = newLatestBill;
                this.setState({ fields });
                errors["latest_bill"] = '';
                this.setState({ errors });
            break;
        default:
            fields["latest_bill"] = '';
            this.setState({ fields });
            errors["latest_bill"] = 'Invalid file type selected';
            this.setState({ errors });
        }
    }

    handleInstallationPropertyNameNumberChange(e) {
        const newInstallationPropertyNameNumber = e.target.value;
        let fields = this.state.fields;
        fields["installation_property_name_number"] = newInstallationPropertyNameNumber;
        this.setState({ fields });
    }

    handleInstallationStreetNameChange(e) {
        const newInstallationStreetName = e.target.value;
        let fields = this.state.fields;
        fields["installation_street_name"] = newInstallationStreetName;
        this.setState({ fields });
    }

    handleInstallationTownCityChange(e) {
        const newInstallationTownCity = e.target.value;
        let fields = this.state.fields;
        fields["installation_town_city"] = newInstallationTownCity;
        this.setState({ fields });
    }

    handleInstallationCountyChange(e) {
        const newInstallationCounty = e.target.value;
        let fields = this.state.fields;
        fields["installation_county"] = newInstallationCounty;
        this.setState({ fields });
    }

    handleInstallationPostcodeChange(e) {
        const newInstallationPostcode = e.target.value;
        let fields = this.state.fields;
        fields["installation_postcode"] = newInstallationPostcode;
        this.setState({ fields });
    }

    handleValidation() {
        let fields = this.state.fields;
        let errors = this.state.errors;
        let formIsValid = true;

        if(!fields["name"]){
           formIsValid = false;
           errors["name"] = "Please enter your name";
        } else {
            errors["name"] = "";
        }
        
        if(!fields["email"]){
            formIsValid = false;
            errors["email"] = "Please enter your email address";
        } else {
            errors["email"] = "";
        }

        if(!fields["billing_property_name_number"]){
            formIsValid = false;
            errors["billing_property_name_number"] = "Please enter the billing property name/number";
        } else {
            errors["billing_property_name_number"] = "";
        }

        if(!fields["billing_street_name"]){
            formIsValid = false;
            errors["billing_street_name"] = "Please enter the billing street name";
        } else {
            errors["billing_street_name"] = "";
        }

        if(!fields["billing_town_city"]){
            formIsValid = false;
            errors["billing_town_city"] = "Please enter the billing town/city";
        } else {
            errors["billing_town_city"] = "";
        }

        if(!fields["billing_county"]){
            formIsValid = false;
            errors["billing_county"] = "Please enter the billing county";
        } else {
            errors["billing_county"] = "";
        }

        if(!fields["billing_postcode"]){
            formIsValid = false;
            errors["billing_postcode"] = "Please enter the billing postcode";
        } else {
            errors["billing_postcode"] = "";
        }

        if(!fields["installation_property_name_number"]){
            formIsValid = false;
            errors["installation_property_name_number"] = "Please enter the installation property name/number";
        } else {
            errors["installation_property_name_number"] = "";
        }

        if(!fields["installation_street_name"]){
            formIsValid = false;
            errors["installation_street_name"] = "Please enter the installation street name";
        } else {
            errors["installation_street_name"] = "";
        }

        if(!fields["installation_town_city"]){
            formIsValid = false;
            errors["installation_town_city"] = "Please enter the installation town/city";
        } else {
            errors["installation_town_city"] = "";
        }

        if(!fields["installation_county"]){
            formIsValid = false;
            errors["installation_county"] = "Please enter the installation county";
        } else {
            errors["installation_county"] = "";
        }

        if(!fields["installation_postcode"]){
            formIsValid = false;
            errors["installation_postcode"] = "Please enter the installation postcode";
        } else {
            errors["installation_postcode"] = "";
        }

        if(!fields["number"]){
            formIsValid = false;
            errors["number"] = "Please enter the number you wish to port";
        } else {
            errors["number"] = "";
        }
        
        if(!fields["current_provider"]){
            formIsValid = false;
            errors["current_provider"] = "Please enter your current provider";
        } else {
            errors["current_provider"] = "";
        }
        
        if(!fields["latest_bill"] && errors["latest_bill"] === '') {
            formIsValid = false;
            errors["latest_bill"] = "Please upload your latest bill";
        } else if (errors["latest_bill"] !== '') {
            formIsValid = false;
        }

        this.setState({errors: errors});
        return formIsValid;
    }

    render() {
        if (!this.state.submitted)
        return (
            <div className="App m-5">
                <div id="customerDetails" className="columns is-mobile is-centered is-vcentered mt-3">
                    <div className="column is-full-mobile is-two-thirds-tablet is-half-desktop is-one-third-widescreen is-one-quarter-fullhd">
                        <div className="block">
                            <h1 className="title is-3 mb-5">Number Port Request Details</h1>
                            <div className="box mt-1">
                                <h2 className="title is-6 mb-3">Your Details</h2>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.name.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.name}</p>}
                                        <input className={`input ${this.state.errors.name.length > 0 ? "is-danger" : ""}`} placeholder="Name" id="name" type="text" value={this.state.fields.name} onChange={this.handleNameChange} />
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.email.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.email}</p>}
                                        <input className={`input ${this.state.errors.email.length > 0 ? "is-danger" : ""}`} placeholder="Email address" id="email" type="email" value={this.state.fields.email} onChange={this.handleEmailChange} />
                                    </div>
                                </div>
                                <h2 className="title is-6 mb-1 mt-5">Company Details</h2>
                                <p className="mb-1">(if requesting on behalf of a business)</p>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.company.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.company}</p>}
                                        <input className={`input ${this.state.errors.company.length > 0 ? "is-danger" : ""}`} placeholder="Company Name" id="company" type="text" value={this.state.fields.company} onChange={this.handleCompanyChange} />
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.company_reg_no.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.company_reg_no}</p>}
                                        <input className={`input ${this.state.errors.company_reg_no.length > 0 ? "is-danger" : ""}`} placeholder="Company Reg No" id="companyRegNo" type="text" value={this.state.fields.company_reg_no} onChange={this.handleCompanyRegNoChange} />
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.job_title.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.job_title}</p>}
                                        <input className={`input ${this.state.errors.job_title.length > 0 ? "is-danger" : ""}`} placeholder="Job Title" id="jobTitle" type="text" value={this.state.fields.job_title} onChange={this.handleJobTitleChange} />
                                    </div>
                                </div>

                                <h2 className="title is-6 mb-3 mt-5">Billing Address</h2>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.billing_property_name_number.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.billing_property_name_number}</p>}
                                        <input className={`input ${this.state.errors.billing_property_name_number.length > 0 ? "is-danger" : ""}`} placeholder="Billing Property Name / Number" id="billingProperyNameNumber" type="text" value={this.state.fields.billing_property_name_number} onChange={this.handleBillingPropertyNameNumberChange} />
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.billing_street_name.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.billing_street_name}</p>}
                                        <input className={`input ${this.state.errors.billing_street_name.length > 0 ? "is-danger" : ""}`} placeholder="Billing Street Name" id="billingStreetName" type="text" value={this.state.fields.billing_street_name} onChange={this.handleBillingStreetNameChange} />
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.billing_town_city.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.billing_town_city}</p>}
                                        <input className={`input ${this.state.errors.billing_town_city.length > 0 ? "is-danger" : ""}`} placeholder="Billing Town" id="billingTownCity" type="text" value={this.state.fields.billing_town_city} onChange={this.handleBillingTownCityChange} />
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.billing_county.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.billing_county}</p>}
                                        <input className={`input ${this.state.errors.billing_county.length > 0 ? "is-danger" : ""}`} placeholder="Billing County" id="billingCounty" type="text" value={this.state.fields.billing_county} onChange={this.handleBillingCountyChange} />
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.billing_postcode.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.billing_postcode}</p>}
                                        <input className={`input ${this.state.errors.billing_postcode.length > 0 ? "is-danger" : ""}`} placeholder="Billing Postcode" id="billingPostcode" type="text" value={this.state.fields.billing_postcode} onChange={this.handleBillingPostcodeChange} />
                                    </div>
                                </div>

                                <h2 className="title is-6 mb-3 mt-5">Number Porting Details</h2>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.number.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.number}</p>}
                                        <input className={`input ${this.state.errors.number.length > 0 ? "is-danger" : ""}`} placeholder="Phone Number" id="number" type="text" value={this.state.fields.number} onChange={this.handleNumberChange} />
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.current_provider.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.current_provider}</p>}
                                        <input className={`input ${this.state.errors.current_provider.length > 0 ? "is-danger" : ""}`} placeholder="Current provider" id="currentProvider" type="text" value={this.state.fields.current_provider} onChange={this.handleCurrentProviderChange} />
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.billing_acct_no.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.billing_acct_no}</p>}
                                        <input className={`input ${this.state.errors.billing_acct_no.length > 0 ? "is-danger" : ""}`} placeholder="Billing account number" id="billingAcctNo" type="text" value={this.state.fields.billing_acct_no} onChange={this.handleBillingAcctNoChange} />
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="control is-expanded">
                                        <h2 className="title is-6 mb-1 mt-5">Latest Bill</h2>
                                        <p className="mb-1">(pdf or image file)</p>
                                        <p className="mb-1">Please ensure the number you want to port is visible on the bill.</p>
                                        {this.state.errors.latest_bill.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.latest_bill}</p>}
                                        <input className={`input ${this.state.errors.latest_bill.length > 0 ? "is-danger" : ""}`} id="latestBill" type="file" accept=".pdf,.jpg,.jpeg,.png,.gif,.webp,.tif,.tiff,.bmp,.svg" onChange={this.handleLatestBillChange} />
                                    </div>
                                </div>

                                <h2 className="title is-6 mb-1 mt-5">Installation Address</h2>
                                <label className="checkbox mb-1">
                                    <input type="checkbox" className="mr-1" defaultChecked={this.state.addressMatch} onChange={this.handleAddressMatchChange} />
                                    Use billing address for installation address
                                </label>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.installation_property_name_number.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.installation_property_name_number}</p>}
                                        <input className={`input ${this.state.errors.installation_property_name_number.length > 0 ? "is-danger" : ""}`} placeholder="Installation Property Name / Number" id="installationProperyNameNumber" type="text" value={this.state.fields.installation_property_name_number} onChange={this.handleInstallationPropertyNameNumberChange} />
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.installation_street_name.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.installation_street_name}</p>}
                                        <input className={`input ${this.state.errors.installation_street_name.length > 0 ? "is-danger" : ""}`} placeholder="Installation Street Name" id="installationStreetName" type="text" value={this.state.fields.installation_street_name} onChange={this.handleInstallationStreetNameChange} />
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.installation_town_city.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.installation_town_city}</p>}
                                        <input className={`input ${this.state.errors.installation_town_city.length > 0 ? "is-danger" : ""}`} placeholder="Installation Town" id="installationTownCity" type="text" value={this.state.fields.installation_town_city} onChange={this.handleInstallationTownCityChange} />
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.installation_county.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.installation_county}</p>}
                                        <input className={`input ${this.state.errors.installation_county.length > 0 ? "is-danger" : ""}`} placeholder="Installation County" id="installationCounty" type="text" value={this.state.fields.installation_county} onChange={this.handleInstallationCountyChange} />
                                    </div>
                                </div>
                                <div className="field">
                                    <div className="control is-expanded">
                                        {this.state.errors.installation_postcode.length > 0 && <p className='has-text-danger has-text-left'>{this.state.errors.installation_postcode}</p>}
                                        <input className={`input ${this.state.errors.installation_postcode.length > 0 ? "is-danger" : ""}`} placeholder="Installation Postcode" id="installationPostcode" type="text" value={this.state.fields.installation_postcode} onChange={this.handleInstallationPostcodeChange} />
                                    </div>
                                </div>

                                <label className="checkbox mb-3">
                                    <input type="checkbox" className="mr-1" defaultChecked={this.state.confirm} onChange={this.handleConfirmChange} />
                                    Tick to confirm you understand this constitutes a request to port the specified number from your current provider to 1310 Ltd, and that this incurrs a charge of £25 + VAT.
                                </label>

                                <div className="field">
                                    <div className="control">
                                        {this.state.errors.generic && <p className='has-text-centered mb-2'><strong>Sorry, an error occurred while validating your account details.<br />Please <a target="_blank" rel="noreferrer" href="https://1310.io/contact">send us a message</a> or call us on <a href="tel:03333001310">0333 300 1310</a> to discuss.</strong></p>}
                                        <button className="button is-primary" disabled={!this.state.confirm} onClick={this.handleSubmitClick}>
                                            {this.state.loading ? <div className="fa-2x"><i className="fas fa-spinner fa-pulse"></i></div> : 'Submit'}
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        );
        else return (
            <div className="App m-5">
                <div id="submittedConfirmation" className="columns is-mobile is-centered is-vcentered mt-3">
                    <div className="column is-full-mobile is-two-thirds-tablet is-half-desktop is-one-third-widescreen is-one-quarter-fullhd">
                        <div id="system-confirmation" className="card selected">
                            <div className="card-header">
                                <div className="card-header-title is-centered">
                                    <h2 className="subtitle is-5">Request Sumbitted</h2>
                                </div>
                            </div>
                            <div className="card-content">
                                <h1 className="title is-4 mt-3">Thank you for your request</h1>
                                <p className="m-5">We will be in touch soon to confirm your request details.</p>
                                <button className="button is-primary mb-3" onClick={this.handleHomeClick}>Home</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}